"use client";
import { SnackbarProvider } from "notistack";

const NotificationProvider = ({ children }) => {
  return (
    <SnackbarProvider
      maxSnack={3}
      disableWindowBlurListener={true}
      autoHideDuration={3000}
      hideIconVariant
    >
      {children}
    </SnackbarProvider>
  );
};

export default NotificationProvider;
